module.exports = __webpack_public_path__ + "static/media/young-indian-agronomist-banker-showing-tablet-with-farmers-agriculture-field.a12d5af4.jpg";